import React from "react";
import Alert from "react-bootstrap/Alert";
import { Helmet } from "react-helmet-async";
import CancelModal from "../../../../components/cancel-modal/cancel-modal";
import ConfirmationModal from "../../../../components/confirmation-modal/confirmation-modal";
import "./admin-group-create-panel.scss";
import PropTypes from "prop-types";

const AdminGroupFormTopColumnNew = ({
  alertConfig,
  setAlertConfig,
  panelVisibility,
  setPanelVisibility,
  isEdit,
  isView,
  Name,
  history,
}) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{isEdit ? "TRIYO · " + Name : "TRIYO · Create Group"}</title>
      </Helmet>
      {alertConfig.showAlert && (
        <Alert
          show={alertConfig.showAlert}
          onClose={() =>
            setAlertConfig({
              showAlert: false,
            })
          }
          variant={alertConfig.alertVariant}
          dismissible
        >
          <Alert.Heading>{alertConfig.alertAction}</Alert.Heading>
          <p>{alertConfig.alertMessage}</p>
        </Alert>
      )}
      {panelVisibility.showCancelPanel && (
        <CancelModal
          show={panelVisibility.showCancelPanel}
          onHide={() => {
            setPanelVisibility((prev) => ({ ...prev, showCancelPanel: false }));
          }}
          redirectURL={"/admin?tab=groups"}
        />
      )}
      {panelVisibility.showConfirmPanel && (
        <ConfirmationModal
          show={panelVisibility.showConfirmPanel}
          onHide={() => {
            history.push("/admin?tab=groups");
          }}
          redirectURL={"/admin?tab=groups"}
          header={!isEdit && "Create Group Confirmation"}
          confirmationText={!isEdit && "Group has been created successfully."}
        />
      )}
      <h4 className="group-panel-title">
        {isView ? "View Group" : isEdit ? "Edit Group" : "Create Group"}
      </h4>
    </>
  );
};

AdminGroupFormTopColumnNew.propTypes = {
  setPanelVisibility: PropTypes.func.isRequired,
  setAlertConfig: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isView: PropTypes.bool.isRequired,
  alertConfig: PropTypes.object.isRequired,
  panelVisibility: PropTypes.object.isRequired,
  Name: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
};

export default AdminGroupFormTopColumnNew;
